import { useMarketTimer } from '../../hooks/useMarketTimer';
import { useClock } from '../../hooks/useClock';

export default function Header({
  username,
  theme,
  onToggleTheme,
  onToggleSidebar,
  sidebarOpen,
  sidebarDocked = false,
  sidebarState = 'expanded',
}) {
  const mkt = useMarketTimer();
  const clock = useClock();

  return (
    <header className="tmr-header">
      <div className="tmr-header-left">
        <button
          type="button"
          className="tmr-hamburger"
          onClick={onToggleSidebar}
          title={sidebarDocked ? 'Toggle navigation panel' : 'Menu'}
          aria-label={sidebarDocked ? 'Toggle navigation panel' : 'Open navigation menu'}
          aria-controls="sidebar"
          aria-expanded={sidebarOpen}
        >
          <i className={
            sidebarDocked
              ? (sidebarState === 'hidden' ? 'bi bi-layout-sidebar' : 'bi bi-layout-sidebar-inset')
              : 'bi bi-list'
          }
          />
        </button>
        <div className="tmr-brand">
          <div className="tmr-brand-badge" aria-hidden="true">
            <i className="bi bi-graph-up-arrow" />
          </div>
          <div>
            <div className="tmr-brand-name">Tactical Market Radar</div>
            <div className="tmr-brand-sub">EOD &amp; Live Analysis Engine</div>
          </div>
        </div>
      </div>
      <div className="tmr-header-right">
        <div className="tmr-market-timer" title="Market session timer">
          <span className="mkt-label">{mkt.label}</span>
          <span className="mkt-countdown">{mkt.countdown}</span>
        </div>
        <div className="tmr-header-clock">
          <span className="time">{clock.time}</span>
          <div className="date-stack">
            <span className="date-line">{clock.date}</span>
            <span className="day-line">{clock.day}</span>
          </div>
        </div>
        <div className="tmr-user-info" title={username}>
          <i className="bi bi-person-circle" />
          <span>{username}</span>
        </div>
        <button
          type="button"
          className="tmr-icon-btn"
          onClick={onToggleTheme}
          title="Toggle Theme"
          aria-label="Toggle theme"
        >
          <i className={theme === 'dark' ? 'bi bi-moon-stars-fill' : 'bi bi-sun-fill'} />
        </button>
        <a href="/pages/logout.php" className="tmr-icon-btn" title="Logout" aria-label="Logout">
          <i className="bi bi-power" />
        </a>
      </div>
    </header>
  );
}